import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Login.css";
import loginBg1 from "../assets/login-bg.png";
import loginBg2 from "../assets/login-bg2.png";
import loginBg3 from "../assets/login-bg3.png";

var IMGS = [loginBg1, loginBg2, loginBg3];

function BgSlider() {
  var [active, setActive] = useState(0);
  var idx = useRef(0);
  useEffect(function() {
    var t = setInterval(function() {
      idx.current = (idx.current + 1) % IMGS.length;
      setActive(idx.current);
    }, 4000);
    return function() { clearInterval(t); };
  }, []);
  return (
    <div className="login-bg">
      {IMGS.map(function(src, i) {
        return <img key={i} src={src} alt="" className={i === active ? "login-slide active" : "login-slide"} />;
      })}
      <div className="login-bg-text">
        <h2>From the hills of Uttarakhand, to your kitchen.</h2>
        <p>Authentic Pahadi products — raw, natural, and made with love.</p>
      </div>
    </div>
  );
}

export default function Login() {
  const [mode, setMode] = useState("signin");
  const [authMode, setAuthMode] = useState("email");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [confirmation, setConfirmation] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { signInWithGoogle, signIn, signUp, sendPhoneOTP, verifyPhoneOTP } = useAuth();
  const navigate = useNavigate();

  async function handleGoogle() {
    try {
      setError(""); setLoading(true);
      await signInWithGoogle();
      navigate("/profile");
    } catch (err) {
      setError("Google sign-in failed. Please try again.");
    } finally { setLoading(false); }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      if (mode === "signup") {
        if (!name) { setError("Please enter your name."); setLoading(false); return; }
        await signUp(email, password, name);
      } else {
        await signIn(email, password);
      }
      navigate("/profile");
    } catch (err) {
      if (err.code === "auth/user-not-found") setError("No account found. Please sign up.");
      else if (err.code === "auth/wrong-password") setError("Incorrect password.");
      else if (err.code === "auth/email-already-in-use") setError("Email already registered. Sign in instead.");
      else if (err.code === "auth/weak-password") setError("Password must be at least 6 characters.");
      else setError("Something went wrong. Please try again.");
    } finally { setLoading(false); }
  }

  async function handleSendOTP() {
    setError("");
    var digits = phone.replace(/\D/g, "").slice(-10);
    if (!/^[6-9]\d{9}$/.test(digits)) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }
    setLoading(true);
    try {
      var result = await sendPhoneOTP("+91" + digits, "recaptcha-container");
      setConfirmation(result);
      setOtpSent(true);
    } catch (err) {
      console.error(err);
      setError("Couldn't send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  async function handleVerifyOTP() {
    setError("");
    if (otp.length !== 6) { setError("Please enter the 6-digit code."); return; }
    setLoading(true);
    try {
      await verifyPhoneOTP(confirmation, otp);
      navigate("/profile");
    } catch (err) {
      setError("Invalid code. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <BgSlider />
      <div className="login-card">
        <div className="login-brand">
          <img src="/logo.png" alt="PureJar" className="login-logo" />
          <h1>Welcome to PureJar</h1>
          <p>Proudly Pahadi</p>
        </div>
        <p className="login-tagline">From the hills of Uttarakhand, straight to your kitchen.</p>
        {error && <div className="alert alert-error">{error}</div>}

        <button className="google-btn" onClick={handleGoogle} disabled={loading}>
          <img src="https://www.google.com/favicon.ico" alt="Google" width="18" />
          Continue with Google
        </button>

        <div className="login-divider"><span>or</span></div>

        <div className="login-method-toggle">
          <button type="button" className={authMode === "email" ? "active" : ""} onClick={() => { setAuthMode("email"); setError(""); }}>Email</button>
          <button type="button" className={authMode === "phone" ? "active" : ""} onClick={() => { setAuthMode("phone"); setError(""); }}>Phone</button>
        </div>

        {authMode === "phone" ? (
          <div className="phone-auth">
            {!otpSent ? (
              <>
                <div className="form-group">
                  <label>Phone Number</label>
                  <div className="phone-input-wrap">
                    <span className="phone-prefix">+91</span>
                    <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="10-digit mobile" maxLength="10" />
                  </div>
                </div>
                <button type="button" className="btn-primary" style={{ width: "100%" }} onClick={handleSendOTP} disabled={loading}>
                  {loading ? "Sending..." : "Send OTP"}
                </button>
              </>
            ) : (
              <>
                <div className="form-group">
                  <label>Enter OTP</label>
                  <input type="tel" value={otp} onChange={e => setOtp(e.target.value)} placeholder="6-digit code" maxLength="6" className="otp-input" />
                  <span className="otp-hint">Code sent to +91 {phone}</span>
                </div>
                <button type="button" className="btn-primary" style={{ width: "100%" }} onClick={handleVerifyOTP} disabled={loading}>
                  {loading ? "Verifying..." : "Verify & Sign In"}
                </button>
                <button type="button" className="otp-resend" onClick={() => { setOtpSent(false); setOtp(""); }}>← Change number</button>
              </>
            )}
          </div>
        ) : (
          <>
            <div className="login-toggle">
              <button className={mode === "signin" ? "active" : ""} onClick={() => setMode("signin")}>Sign In</button>
              <button className={mode === "signup" ? "active" : ""} onClick={() => setMode("signup")}>Create Account</button>
            </div>
            <form onSubmit={handleSubmit}>
              {mode === "signup" && (
                <div className="form-group">
                  <label>Full Name</label>
                  <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Your full name" required />
                </div>
              )}
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder={mode === "signup" ? "Minimum 6 characters" : "Your password"} required />
              </div>
              <button type="submit" className="btn-primary" style={{ width: "100%" }} disabled={loading}>
                {loading ? "Please wait..." : mode === "signup" ? "Create Account" : "Sign In"}
              </button>
            </form>
          </>
        )}

        <div id="recaptcha-container"></div>

        <p className="login-footer">
          By continuing you agree to PureJar's terms.<br />
          <Link to="/">&#8592; Back to home</Link>
        </p>
        <div className="login-trust">
          <span>&#10003; 100% Natural</span>
          <span>&#10003; FSSAI Licensed</span>
          <span>&#10003; Secure Payments</span>
        </div>
      </div>
    </div>
  );
}
